import { z } from 'zod';
export const ApiTokenSchema = z.object({
    id: z.string(),
    name: z.string(),
    createdAt: z.string(),
    lastUsedAt: z.string().nullable(),
});
export const ApiTokensResponseSchema = z.object({ tokens: z.array(ApiTokenSchema) });
export const CreateApiTokenRequestSchema = z.object({ name: z.string().trim().min(1, 'Required').max(64) });
/** `secret` is the only copy of the token; it is shown once. */
export const CreateApiTokenResponseSchema = z.object({ token: ApiTokenSchema, secret: z.string() });
//# sourceMappingURL=api-tokens.js.map